export default __webpack_public_path__ + "static/gw2-banner-events-8ade9d4c917e6c86b5ea718f4dfdfc88.png";